import { Extension } from '@tiptap/react';

// Extend Tiptap command and storage types
declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    regenerate: {
      regenerateSection: () => ReturnType;
    };
  }

  interface Storage {
    regenerate: {
      onRegenerate: ((sectionIndex: number) => Promise<void>) | null;
      sectionIndex: number;
      canRegenerate: boolean;
      isRegenerating: boolean;
    };
  }
}

export const RegenerateExtension = Extension.create({
  name: 'regenerate',

  addStorage() {
    return {
      onRegenerate: null as ((sectionIndex: number) => Promise<void>) | null,
      sectionIndex: 0,
      canRegenerate: true,
      isRegenerating: false,
    };
  },

  addCommands() {
    return {
      regenerateSection: () => () => {
        const { onRegenerate, sectionIndex, canRegenerate, isRegenerating } =
          this.editor.storage.regenerate;
        
        if (!onRegenerate || !canRegenerate || isRegenerating) {
          return false;
        }

        onRegenerate(sectionIndex).catch(console.error);
        return true;
      },
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Shift-r': () => this.editor.commands.regenerateSection(),
    };
  },
});